export const Roles = {
    ADMIN: 1,
    OBSERVER: 2,
    WORKER: 3,
    MAP_VIEWER: 4,
    PRO_APP_USER: 5,
    COMPANY_SUPER_USER: 6
};

const rolePriorities = {
    [Roles.COMPANY_SUPER_USER]: 0,
    [Roles.OBSERVER]: 1,
    'other': 2,
};
export function rolePriority(role) {
    const priority = role != null && rolePriorities[role];
    return priority != null && priority !== false
        ? priority
        : rolePriorities['other'];
}

export const userHelper = {
    methods: {
        newUser: function () {
            return {
                id: null,
                first_name: '',
                last_name: '',
                email: '',
                username: '',
                tax_number: '',
                roles: []
            }
        },

        jsonToUser: function (user) {
            return JSON.parse(JSON.stringify(user)) // deep cloning of the vehicle object
        },

        hasAdmin: function (roles) {
            return roles.find(role => role.role === Roles.ADMIN) !== undefined
        },

        hasObserver: function (roles) {
            return roles.find(role => role.role === Roles.OBSERVER) !== undefined
        },

        hasWorker: function (roles) {
            return roles.find(role => role.role === Roles.WORKER) !== undefined
        },

        hasMapViewer: function (roles) {
            return roles.find(role => role.role === Roles.MAP_VIEWER) !== undefined
        },

        hasCompanySuperUser: function (roles) {
            return roles.find(role => role.role === Roles.COMPANY_SUPER_USER) !== undefined
        },

        hasContractSystem(user) {
            return user.api_key_types ? user.api_key_types.contract_system : false
        },

        hasIntegrationSystem(user) {
            return user.api_key_types ? user.api_key_types.integration_system : false
        },

        hasLouhiInfra(user) {
            return user && user.api_key_types ? user.api_key_types.louhi_infra : false
        },

        getRoleName: function (role) {
            switch (role) {
                case Roles.ADMIN:
                    return this.$t('users.admin')
                case Roles.OBSERVER:
                    return this.$t('users.observer')
                case Roles.WORKER:
                    return this.$t('users.worker')
                case Roles.MAP_VIEWER:
                    return this.$t('users.map_viewer')
                case Roles.PRO_APP_USER:
                    return this.$t('users.pro_app_user')
                case Roles.COMPANY_SUPER_USER:
                    return this.$t('users.company_super_user')
            }
            return this.$t('common.unknown')
        },
        validEmail: function (email) {
            if (email) {
                let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            }
            return false;
        },

        getAdminMenu() {
            return [
                {
                    "title": this.$t('menu.admin_users'), "icon": "users", "viewName": "userAdmin",
                    "children": [
                        { "title": this.$t('menu.admin_users'), "viewName": "users" },
                        { "title": this.$t('menu.license_report'), "viewName": "licenseReport" },
                        { "title": this.$t('menu.license_admin_report'), "viewName": "licenseAdminView" },
                    ]
                },
                {
                    "title": this.$t('menu.admin'), "icon": "cog", "viewName": "admin",
                    "children": [
                        { "title": this.$t('menu.admin_companies'), "viewName": "companies" },
                        { "title": this.$t('menu.admin_company_relationships'), "viewName": "companyRelationships" },
                        { "title": this.$t('menu.observation_groups'), "viewName": "observationGroups" },
                        { "title": this.$t('menu.observation_types'), "viewName": "observationTypes" },
                        { "title": this.$t('menu.material_types'), "viewName": "materialTypes" },
                        { "title": this.$t('menu.external_ids'), "viewName": "externalContractIds" },
                        { "title": this.$t('certificate.type_title'), "viewName": "certificateTypes" },
                        { "title": this.$t('menu.pricing_models'), "viewName": "pricingModels" },
                        { "title": this.$t('menu.trip_summary_generator'), "viewName": "contractTripSummaryGenerator" },
                        { "title": this.$t('menu.generate_spreader_data'), "viewName": "spreaderDataGenerator" },
                        { "title": this.$t('menu.api_keys'), "viewName": "apiKeys" },
                        { "title": this.$t('menu.addons'), "viewName": "subscriptions" },
                    ]
                }
            ]
        },

        getWorkerMenu() {
            return  [
                { "title": this.$t('menu.map'), "icon": "map", "viewName": "map" },
                { "title": this.$t('menu.work_assignment'), "icon": "tasks", "viewName": "workAssignmentsUser" },
                {
                    "title": this.$t('menu.fleet_trips'), "icon": "route", "viewName": "searchTrips",
                },
                {
                    "title": this.$t('menu.observations'), "icon": "eye", "viewName": "observations",
                },
                {
                    "title": this.$t('menu.infra'), "icon": "draw-polygon", "viewName": "infraViews",
                    "children": [
                        { "title": this.$t('menu.street_lights'), "viewName": "streetLights" },
                        { "title": this.$t('menu.sewers'), "viewName": "sewers" },
                        { "title": this.$t('menu.traffic_signs'), "viewName": "roadSigns" },
                        { "title": this.$t('menu.material_storages'), "viewName": "materialStorageSearch" },
                        { "title": this.$t('menu.bridges'), "viewName": "bridges" },
                    ]
                },
                {
                    "title": this.$t('menu.safety'), "icon": "clipboard-check", "viewName": "safetyViews",
                    "children": [
                        { "title": this.$t('menu.inspections') , "viewName": "inspections" },
                        { "title": this.$t('menu.mvr_inspections') , "viewName": "mvrInspections" },
                    ]
                },
                {
                    "title": this.$t('menu.stations'), "icon": "industry", "viewName": "stations",
                    "children": [
                        { "title": this.$t('menu.material_stations'), "viewName": "materialStations" },
                        { "title": this.$t('menu.delivery_notes'), "viewName": "deliveryNotes" },
                        { "title": this.$t('menu.unknown_notes'), "viewName": "unknownNotes" },
                    ]
                },
                {
                    "title": this.$t('menu.fleet_register'), "icon": "truck", "viewName": "fleet",
                }
            ]
        },

        getMapViewerMenu() {
            return  [
                { "title": this.$t('menu.map'), "icon": "map", "viewName": "map" },
                {
                    "title": this.$t('menu.fleet_trips'), "icon": "route", "viewName": "searchTrips",
                },
                {
                    "title": this.$t('menu.observations'), "icon": "eye", "viewName": "observations",
                },
                {
                    "title": this.$t('contracts.external.work_diary'), "icon": "user-tie", "viewName": "workDiary"
                }
            ]
        },

        getTicketsMenuItem() {
            return {
                "title": this.$t('menu.tickets'), "icon": "ticket-alt", "viewName": "ticketSystem",
            }
        },

        getSupervisorMenu(ticketSystem, subscription = null) {
            const menu = [
                { "title": this.$t('menu.map'), "icon": "map", "viewName": "map" },
                {
                    "title": this.$t('menu.fleet_trips'), "icon": "route", "viewName": "trips",
                    "children": [
                        { "title": this.$t('menu.search_trip'), "viewName": "searchTrips" },
                        { "title": this.$t('menu.trip_report'), "viewName": "tripReports" },
                        { "title": this.$t('menu.trip_road_report'), "viewName": "roadReports" },
                        { "title": this.$t('menu.fuel_report'), "viewName": "fuelReport" },
                        { "title": this.$t('menu.delivery_notes'), "viewName": "deliveries" },
                        { "title": this.$t('material_reports.title'), "viewName": "materialReports" },
                        { "title": this.$t('menu.spreader_data'), "viewName": "spreaderData" },
                        { "title": this.$t('menu.observation_recordings'), "viewName": "observationsVideos" }
                    ]
                },
                {
                    "title": this.$t('menu.observations'), "icon": "eye", "viewName": "observations",
                    "children": [
                        { "title": this.$t('menu.observations'), "viewName": "observations" },
                        { "title": this.$t('observation_reports.title'), "viewName": "observationReport" }
                    ]
                },
                {
                    "title": this.$t('menu.infra'), "icon": "draw-polygon", "viewName": "infraViews",
                    "children": [
                        { "title": this.$t('menu.street_lights'), "viewName": "streetLights" },
                        { "title": this.$t('menu.sewers'), "viewName": "sewers" },
                        { "title": this.$t('menu.traffic_signs'), "viewName": "roadSigns" },
                        { "title": this.$t('menu.material_storages'), "viewName": "materialStorageSearch" },
                        { "title": this.$t('menu.bridges'), "viewName": "bridges" },
                        { "title": this.$t('menu.areas'), "viewName": "areas" },
                        { "title": this.$t('menu.area_groups'), "viewName": "areaGroups" },
                        { "title": this.$t('menu.area_work'), "viewName": "areaWork" },
                        { "title": this.$t('menu.area_report'), "viewName": "areaReports" },
                        { "title": this.$t('menu.area_equipment'), "viewName": "areaEquipment" },
                        { "title": this.$t('menu.area_defect'), "viewName": "areaDefects" },
                        { "title": this.$t('menu.mixed_waste_bins'), "viewName": "mixedWasteBins" },
                    ]
                },
                {
                    "title": this.$t('menu.safety'), "icon": "clipboard-check", "viewName": "safetyViews",
                    "children": [
                        { "title": this.$t('menu.user_alerts') , "viewName": "userAlerts" },
                        { "title": this.$t('menu.danger_reports') , "viewName": "dangerReports" },
                        { "title": this.$t('menu.inspections') , "viewName": "inspections" },
                        { "title": this.$t('menu.mvr_inspections') , "viewName": "mvrInspections" },
                        //{ "title": this.$t('menu.contractor_reports') , "viewName": "contractorReports" },
                        //{ "title": this.$t('menu.contract_user_reports') , "viewName": "contractUserReports" },
                        { "title": this.$t('menu.subcontractor_approvals') , "viewName": "subcontractorApprovals" },
                        { "title": this.$t('menu.general_guides') , "viewName": "generalGuides" }
                    ]
                },
                {
                    "title": this.$t('menu.supervisor'), "icon": "user-tie", "viewName": "managementViews",
                    "children": [
                        { "title": this.$t('menu.work_report') , "viewName": "workReports" },
                       // { "title": this.$t('menu.work_permission') , "viewName": "workPermissions" },
                       // { "title": this.$t('menu.dispatches') , "viewName": "dispatch" },
                        { "title": this.$t('menu.work_assignment') , "viewName": "workAssignments" },
                        { "title": this.$t('menu.contracts') , "viewName": "contracts" },
                        { "title": this.$t('contracts.external.work_diary') , "viewName": "workDiary" },
                        { "title": this.$t('menu.calendar') , "viewName": "calendar" },
                       // { "title": this.$t('menu.invoicing') , "viewName": "invoicing" },
                        { "title": this.$t('menu.work_time') , "viewName": "workTime" },
                        { "title": this.$t('menu.additional_cost') , "viewName": "additionalCosts" },
                        { "title": this.$t('certificate.user_certificates'), "viewName": "certificates" },
                        { "title": this.$t('menu.certificate_report') , "viewName": "certificateReport" }
                    ]
                },
                {
                    "title": this.$t('menu.stations'), "icon": "industry", "viewName": "stations",
                    "children": [
                        { "title": this.$t('menu.material_stations'), "viewName": "materialStations" },
                        { "title": this.$t('menu.delivery_notes'), "viewName": "deliveryNotes" },
                        { "title": this.$t('menu.unknown_notes'), "viewName": "unknownNotes" },
                    ]
                },
                {
                    "title": this.$t('menu.fleet_register'), "icon": "truck", "viewName": "fleetViews",
                    "children": [
                        { "title": this.$t('menu.fleet_register'), "viewName": "fleet" },
                        { "title": this.$t('menu.tracking_devices'), "viewName": "trackingDevices" },
                        { "title": this.$t('menu.fleet_defects'), "viewName": "fleetDefects" },
                       // { "title": this.$t('menu.fleet_allocation'), "viewName": "fleetAllocation" },
                    ]
                },
            ]

            // Tickets
            if (ticketSystem) {
                menu.push(
                    {
                        "title": this.$t('menu.tickets'), "icon": "ticket-alt", "viewName": "ticketSystem",
                    }
                )
            }
            // Rest standard items
            menu.push(
                {
                "title": this.$t('menu.settings'), "icon": "cogs", "viewName": "settings",
                "children": [
                    { "title": this.$t('menu.notification_lists'), "viewName": "notificationLists" },
                    { "title": this.$t('menu.data_import'), "viewName": "dataImport" },
                    { "title": this.$t('menu.task_types'), "viewName": "taskTypes" },
                    { "title": this.$t('menu.price_lists'), "viewName": "priceLists" },
                    { "title": this.$t('menu.company_defaults'), "viewName": "companyDefaults" },
                    // { "title": this.$t('menu.observation_collections'), "viewName": "observationCollections" },
                    // { "title": this.$t('menu.contract_collections'), "viewName": "contractCollections" },
                ]
            })

            // Add route optimization if subscription is active
            if (subscription?.route_optimization?.is_active === true) {
                menu.push({ "title": this.$t('menu.route_optimization'), "icon": "city", "viewName": "routeOptimization", "group": "menu.group_addons" });
            }

            if (subscription?.dash_cam?.is_active === true) {
                menu.push({ "title": this.$t('menu.video_recordings'), "icon": "video", "viewName": "videoRecordings", "group": "menu.group_addons" });
            }

            return menu
        },

        getSuperuserMenu() {
            return [
                {
                    "title": this.$t('menu.settings'), "icon": "cogs", "viewName": "settings",
                    "children": [
                        //{ "title": this.$t('menu.company_conversions'), "viewName": "conversions" },
                        { "title": this.$t('menu.cost_center'), "viewName": "costCenter" },
                        //{ "title": this.$t('menu.accounts'), "viewName": "accounts" },
                        //{ "title": this.$t('contracts.contract_class.title_plural'), "viewName": "contractClasses" },
                    ]
                },
                {
                    "title": this.$t('menu.admin_users'), "icon": "user", "viewName": "userMgmt",
                    "children": [
                        { "title": this.$t('menu.admin_users'), "viewName": "users" },
                        { "title": this.$t('menu.license_report'), "viewName": "licenseReport" }
                    ]
                }
            ]
        },

        getSubmenuItem(subItem, menuItems) {
            let existingItem = null
            menuItems.forEach(menuItem => {
                if (menuItem.children) {
                    menuItem.children.forEach(item => {
                        if (subItem.viewName === item.viewName) {
                            existingItem = item
                        }
                    })
                }
            })
            return existingItem
        },

        getCombinedSuperMenu(ticketSystem, subscription = null) {
            let menuItems = this.getSupervisorMenu(ticketSystem, subscription)
            const superUserMenu = this.getSuperuserMenu()
            // Combine menus
            superUserMenu.forEach(menuItem => {
                const existingItem = menuItems.find(item => item.viewName === menuItem.viewName)
                if (!existingItem) {
                    // Add whole menu item before help/ about
                    const insertIndex = menuItems.findIndex(
                        item => item.group === 'menu.group_addons'
                    )
                    menuItems.splice(
                        insertIndex >= 0 ? insertIndex : menuItems.length,
                        0,
                        menuItem
                    )
                } else if (menuItem.children) {
                    // Go through existing item and check submenu items
                    menuItem.children.forEach(subItem => {
                        const existingSubItem = this.getSubmenuItem(subItem, menuItems)
                        if (!existingSubItem) {
                            // Add sub menu item
                            existingItem.children.push(subItem)
                        }
                    })
                }
            })
            return menuItems
        }

    }
}
